import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { COMBO_INPUT_ATTRS } from '../constants/combo-input-attrs';

/**
 * Bloqueia sugestão/autocomplete nativo do navegador em combos pesquisáveis do sistema.
 * Aplica-se a inputs de autocomplete customizado e busca interna de dropdowns.
 */
@Directive({
  selector:
    'input.autocomplete-input, .custom-autocomplete-wrapper input, .dropdown-search-input, .dynamic-select-container input',
  standalone: true,
})
export class DisableBrowserAutocompleteDirective implements OnInit {
  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement>,
    private readonly renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    const input = this.elementRef.nativeElement;
    if (!input || input.tagName !== 'INPUT') {
      return;
    }

    Object.entries(COMBO_INPUT_ATTRS).forEach(([key, value]) => {
      this.renderer.setAttribute(input, key, value);
    });

    // Chrome ignora autocomplete="off" em alguns campos; readonly até o foco evita o popup nativo.
    if (!input.hasAttribute('data-combo-autocomplete-guard')) {
      this.renderer.setAttribute(input, 'data-combo-autocomplete-guard', 'true');
      this.renderer.setAttribute(input, 'readonly', 'true');
      this.renderer.listen(input, 'focus', () => {
        this.renderer.removeAttribute(input, 'readonly');
      });
    }
  }
}
